import type { TOC } from '@ember/component/template-only'
import { array } from '@ember/helper'
import { t } from 'ember-intl'
import { not } from 'ember-truth-helpers'
import { Precinct } from 'teacher-ui-client/utils/precincts'
import { CourseProgressAverages } from 'teacher-ui-client/components/giraffe/charts/course-progress/averages'
import { CourseProgressHistory } from 'teacher-ui-client/components/giraffe/charts/course-progress/history'
import { CourseProgressTotals } from 'teacher-ui-client/components/giraffe/charts/course-progress/totals'
import { ReportingDetailedControls } from 'teacher-ui-client/components/reporting/detailed-controls'
import { ReportingNoDataMessageIf } from 'teacher-ui-client/components/reporting/no-data-message-if'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { fullGradeName } from 'teacher-ui-client/helpers/full-grade-name'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import type { CourseProgressReReadingRoute } from 'teacher-ui-client/reporting/ui-scope/re/course-progress/reading/route'
import RouteTemplate from 'ember-route-template'
import { camelize } from '@ember/string'
import { concat } from '@ember/helper'

interface Signature {
  model: ModelFor<CourseProgressReReadingRoute>
}

export const ReCourseProgressReading: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.courseProgressLessons.re"}} />
  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{Boolean @model.readingProgressTotals}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.re.student-summary"
  />
  <ReportingNoDataMessageIf @on={{not @model.readingProgressTotals}}>
    {{#each @model.readingProgressTotals as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <CourseProgressTotals
          @title={{t "reporting.chartTitles.courseProgressTotals"}}
          @summaryTitle={{t (concat "reporting.summaryTitles.courseProgressTotals." (camelize @model.uiScope.scope))}}
          @tooltip={{t "reporting.tooltips.courseProgressTotals"}}
          @data={{gradeData}}
          @product={{@model.product}}
          @precinct={{@model.precinct}}
          @grade={{fullGradeName gradeData.grade_position}}
        />
      </div>
    {{/each}}
    {{#each @model.readingProgressAverages as |gradeData|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <CourseProgressAverages
          @data={{gradeData}}
          @precinct={{Precinct.RE_READING}}
          @title={{t (concat "reporting.chartTitles.courseProgressAverages." (camelize @model.uiScope.scope))}}
          @tooltip={{t "reporting.tooltips.courseProgressAverages"}}
        />
      </div>
    {{/each}}
    {{#if @model.readingProgressHistory}}
      <CourseProgressHistory
        @tooltip={{t "reporting.tooltips.courseProgressHistory.chartInfo"}}
        @students={{@model.scopedStudents}}
        @courseProgressHistory={{@model.readingProgressHistory}}
        @product={{@model.product}}
        @precinct={{@model.precinct}}
        @uiScope={{@model.uiScope.scope}}
        @studentRouteName="reporting.ui-scope.re.student-summary"
        @themeKey={{ThemeKeys.blue}}
      />
    {{/if}}
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(ReCourseProgressReading)
